import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateApprovedDTO,
  WithdrawApiService,
} from 'features/withdraw/api/withdraw-api.service';

import { withdrawQueryKeys } from './query-keys';
const { createSuperAdminManualApi } = WithdrawApiService();
// ../api/withdraw-api.service
export const useCreateSuperAdminManual = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateApprovedDTO) => {
      return createSuperAdminManualApi(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        // TODO: invalidate week view endpoint as well, when ready
        queryClient.invalidateQueries({
          queryKey: withdrawQueryKeys.all,
        });
        if (data?.response_status == 0) {
          message.error(data?.response_message);
        } else {
          message.success(data?.response_message);
        }
      },
    },
  );
};
